import linkShapeSvg from '@assets/svg/ink-shape.svg'
import { withTransaction } from '@elastic/apm-rum-react'
import { MySquid, onConfigChange } from '@hub/shared'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SubscriptionLike } from 'rxjs'

const MaintenancePageComponent = (props: any) => {
  const onConfigChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [configs, setConfig] = useState<MySquid | null>(null)
  const { t } = useTranslation()

  useEffect(() => {
    onConfigChangeSubscription.current = onConfigChange.subscribe((configChanged: MySquid | any) => {
      if (configChanged?._id) {
        setConfig(configChanged)
      }
    })
    return () => {
      onConfigChangeSubscription.current?.unsubscribe()
    }
  }, [onConfigChangeSubscription])

  const redirectToHome = () => {
    history.pushState({}, '', '/login')
    return <div />
  }

  if (!props.general.maintenance) {
    redirectToHome()
  }

  let img = <object style={{ maxWidth: '310px' }} aria-labelledby="Maintence Image" data={linkShapeSvg} type="image/svg+xml" />
  if (configs?._id) {
    img = <i className="mb-5 fa-solid fa-user-robot-xmarks" style={{ fontSize: '150px', color: 'var(--primary_color)' }} />
  }
  return (
    <div className="not-found text-center">
      <figure className="mb-5 display-flex align-items-center justify-content-center" style={{ overflow: 'hidden' }}>
        {img}
      </figure>
      <h1>{t('maintenance:title')}</h1>
      <p className="gray" style={{ maxWidth: '250px', margin: '0 auto 1rem' }}>
        {t('maintenance:text')}
      </p>
    </div>
  )
}
export default withTransaction('MaintenancePageComponent', 'component')(MaintenancePageComponent)
